const COOKIE_KEYS = {
  COOKIE_AGREEMENT: 'cookieAgreement',
};

export default COOKIE_KEYS;
